import { FALLBACK_DATE_FORMAT, FALLBACK_DATE_SEPARATOR } from 'forms-utils-lib/date/DateConstants';
export const getFormattedDate = (format = FALLBACK_DATE_FORMAT, separator = FALLBACK_DATE_SEPARATOR) => format.replace(/-/g, separator);